import script from "./AccountSecurity.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountSecurity.vue?vue&type=script&setup=true&lang=js"

import "./AccountSecurity.vue?vue&type=style&index=0&id=4c62768c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c62768c"]])

export default __exports__